import React from "react";
import { Box, BoxProps } from "@mui/material";
interface TabPanelProps {
  children?: React.ReactNode;
  overflow?: BoxProps["overflow"];
  index: string;
  value: string;
  flexDirection?: "row" | "column";
}
function TabPanel(props: TabPanelProps) {
  const { children, value, index } = props;

  return value === index ? (
    <Box
      overflow={props.overflow || "hidden"}
      height="100%"
      width="100%"
      display="flex"
      flexDirection={props.flexDirection}>
      {children}
    </Box>
  ) : (
    <div />
  );
}
export default TabPanel;
